import * as React from "react";
import type { SVGProps } from "react";
const SvgCaretLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill={props.color || "#2E2040"}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M165.66 202.34a8 8 0 0 1-11.32 11.32l-80-80a8 8 0 0 1 0-11.32l80-80a8 8 0 0 1 11.32 11.32L91.31 128Z" />
  </svg>
);
export default SvgCaretLeft;
